<template>
  <div>
    <el-row v-if="!isDriverRole" :gutter="24">
      <el-col :span="24">
        <p>
          <b>Выберите перевозчика из ваших контрагентов:</b>
        </p>
        <span
          v-if="!isSelectContr"
          class="href-select"
          @click="innDialogViewSet"
        >
          Выбрать
        </span>
        <el-dialog
          title="Выбор контрагента"
          :visible.sync="innDialogView"
          width="50%"
          append-to-body
          :close-on-click-modal="false"
        >
          <select-contragent @selected="selectContragent" />
        </el-dialog>

        <span v-if="isSelectContr" class="selected-contr">
          Вы выбрали: {{ textContragent }}
          <span v-if="!readonly" class="href-select" @click="innDialogViewSet">
            Выбрать другого
          </span>
        </span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import SelectContragent from '@/components/Contragents/SelectContragent'
import mixinMain from '../Mixins/main'

export default {
  name: 'SetCarrier',
  components: { SelectContragent },
  mixins: [mixinMain],
  props: {
    driver: {
      type: Object,
      default: () => {},
      required: false,
    },
  },
  data() {
    return {
      innDialogView: false,
      isSelectContr: false,
      needContract: false,
      textContragent: '',
      returnData: {
        carrier_inn: '',
        carrier_name: '',
      },
      source_model_id: 1,
    }
  },
  create() {
    if (this.isDriverRole) {
      this.returnData.carrier_inn = this.cur_org_inn
      this.returnData.carrier_name = this.curOrgShortName
    }
  },
  watch: {
    driver: {
      immediate: true,
      handler(newVal) {
        if (String(newVal.carrier_inn) !== '') {
          this.innDialogView = false
          this.isSelectContr = true
          this.textContragent = newVal.carrier_name
          this.returnData.carrier_inn = newVal.carrier_inn
          this.returnData.carrier_name = newVal.carrier_name
        } else {
          this.innDialogView = false
          this.isSelectContr = false
          this.textContragent = ''
          this.returnData.carrier_inn = ''
          this.returnData.carrier_name = ''
        }
      },
    },
  },
  methods: {
    selectContragent(id) {
      this.innDialogView = false
      let contragent = this.$store.getters.getContragent(id)

      this.isSelectContr = true
      this.textContragent = contragent.org_name
      this.returnData.carrier_inn = contragent.inn
      this.returnData.carrier_name = contragent.org_name

      this.changed()
    },
    innDialogViewSet() {
      this.innDialogView = true
    },
  },
}
</script>

<style scoped>
.href-select {
  color: #409eff;
  text-decoration: underline;
  font-family: 'Rubik Medium', sans-serif;
  font-size: 14px;
  cursor: pointer;
}
.href-select:hover {
  text-decoration: none;
}
.selected-contr {
  font-size: 14px !important;
  color: #b5b5b5;
  font-family: 'Rubik Medium', sans-serif;
}
</style>
